import brandColors from 'main/hotelBrandColors.json'
import { useSelector } from 'react-redux'
import { getForegroundColor } from 'utils/colorHelpers'

const BASE_LOGO_URL = 'https://cdn.swaypay.io/logos'

/**
 *
 * @typedef Params
 * @property {string} subsidiaryShortLinkToken
 * @property {string} parentChainCode
 *
 * @param {(Params | undefined)} params
 * @returns
 */

function getBrandColor(parentChainCode, hotelIdentifier, brand) {
  let colors
  try {
    if (parentChainCode === 'independent') {
      colors = brandColors.independent?.[hotelIdentifier]
    } else {
      colors = brandColors[parentChainCode][brand]
    }
    return colors ?? brandColors.fallback
  } catch (e) {
    return brandColors.fallback
  }
}

function getLogoUrl(parentChainCode, hotelIdentifier, brand) {
  return parentChainCode === 'independent'
    ? BASE_LOGO_URL + '/independents/' + hotelIdentifier + '.png'
    : BASE_LOGO_URL + '/brands/' + brand + '.png'
}

function useBrand(params) {
  const subsidiaryShortLinkToken = useSelector(
    s => s.hotelDetails.subsidiaryShortLinkToken
  )

  let brand = subsidiaryShortLinkToken.split('/')[0]
  let parentChainCode = useSelector(s => s.hotelDetails.parentChainCode)
  let hotelIdentifier = subsidiaryShortLinkToken.split('/')[1]

  if (params) {
    brand = params.subsidiaryShortLinkToken.split('/')[0]
    parentChainCode = params.parentChainCode
    hotelIdentifier = params.subsidiaryShortLinkToken.split('/')[1]
  }

  const colors = getBrandColor(parentChainCode, hotelIdentifier, brand)
  const logoUrl = getLogoUrl(parentChainCode, hotelIdentifier, brand)

  const actionText = getForegroundColor(colors.action)
  const primaryText = getForegroundColor(colors.primary)

  return { brand, colors: { ...colors, actionText, primaryText }, logoUrl }
}

export default useBrand
